import adminAxios from 'src/admin-axios';
import appAxios from 'src/app-axios';
import Constants from 'src/constants';

export const adminuser = {
    namespaced: true,
    state: {
        user: null,
    },
    getters: {
        isLogged: state => !!state.user,
    },
    actions: {
        async login ({ commit, dispatch }, credentials) {
            try {
                const response = await adminAxios.post('/login', credentials);
                commit('setUserData', response.data);
            } catch (exception) {
                dispatch('alert/onAlert', {
                    message: exception.response.data.message,
                    type: Constants.ALERT_TYPE_ERROR,
                }, { root: true });
                throw exception;
            }
        },
        async logout ({ commit }) {
            try {
                await adminAxios.post('/logout');
            } catch (exception) {
                // do nothing here.
            } finally {
                commit('clearUserData');
            }
        },
    },
    mutations: {
        setUserData (state, userData) {
            state.user = userData;
            adminAxios.defaults.headers.common.Authorization = `Bearer ${userData.token}`;
            appAxios.defaults.headers.common.Authorization = `Bearer ${userData.token}`;
            localStorage.setItem('user', JSON.stringify(userData));
        },
        clearUserData (state) {
            localStorage.removeItem('user');
            state.user = null;
            location.reload();
        },
    },
};
